import axios from 'axios';

const BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000';

/**
 * Send a message to the TGH AI Chatbot backend.
 */
export async function sendChatMessage({ message, sessionId }) {
  const response = await axios.post(`${BASE_URL}/api/chatbot/chat`, {
    message,
    sessionId: sessionId || undefined,
  });
  return response.data;
}

/**
 * Fetch full tour package details for showcase.
 */
export async function fetchTourDetails(id) {
  const response = await axios.get(`${BASE_URL}/api/get-tour/${id}`);
  return response.data;
}

/**
 * Fetch full wellness package details for showcase.
 */
export async function fetchWellnessDetails(id) {
  const response = await axios.get(`${BASE_URL}/api/wellness-packages/${id}`);
  return response.data;
}